import styled from 'styled-components'

import { LmfAnalyticsProvider, Minus as MinusIcon, atXs, fromMd } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { CartContainer } from '../../../../brunswick/containers/cart'
import { ItemCount, Title } from '../styles'

export const MiniCartDialogHeader = styled.div`
  align-items: center;
  background-color: ${o => o.theme.color.fill.background};
  display: flex;
  justify-content: flex-start;
  padding: ${o => o.theme.spacing(5, 4.125)};
  position: sticky;
  top: 0;
  z-index: ${o => o.theme.zIndex.foregroundContent};

  svg {
    path {
      stroke-width: 1;
    }
  }

  ${fromMd} {
    padding: ${o => o.theme.spacing(5, 10)};
  }

  ${atXs} {
    padding: ${o => o.theme.spacing(0, 4.125)};
  }
`

export const MiniCartDialogHeaderContent = () => {
  const { cart } = CartContainer.useContainer()
  const { cart: miniCartCopy } = useTranslation()

  return (
    <LmfAnalyticsProvider title='Cart Header'>
      <Title asTag='h2' textTransform='uppercase' id='minicartDialogTitle'>
        {miniCartCopy.title}
      </Title>
      {cart.itemCount > 0 ? (
        <>
          <MinusIcon stroke='currentColor' />
          <ItemCount>{cart.itemCount}</ItemCount>
        </>
      ) : null}
    </LmfAnalyticsProvider>
  )
}
